<template>
  <div class="chartContainer">
    <vue-apex-charts ref="chart" type="bar" width="450" height="500" :series="series" :options="chartOptions" @dataPointSelection="dataPointSelectionHandler"  ></vue-apex-charts>
  </div>
</template>

<script>

import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'LimsSampleStats',
  components: {
    VueApexCharts
  },
  props: {
    projectId: {
      type:Number
    }
  },
  data() {
    return {
      series: [
        {
          name: this.$t('GradeControl.Sample.ImportedNoExclusion'),
          data: []
        }, {
          name: this.$t('GradeControl.Sample.ImportedWithExclusion'),
          data: []
        }, {
          name: this.$t('GradeControl.Sample.Orphan'),
          data: []
        }, {
          name:  this.$t('GradeControl.Sample.NotImported'),
          data: []
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: false
          }
        },
        colors:['#00e396', '#008ffb', '#ffbf00', '#ff0000'],
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            horizontal: false
          }
        },
        xaxis: {
          type: 'datetime'
        },
        legend: {
          position: 'top',
          offsetY: 30
        },
        fill: {
          opacity: 1
        }
      }
    }
  },
  methods: {
    refreshData(startDate, endDate) {
      return new Promise((resolve, reject) => {
        this.$webApi.get("geo/gradecontrol/limssampleresult/GetDailyStats/", {
          params: {
            startDate,
            endDate,
            projectId: this.projectId
          }
        }).then((response) => {

          const dates = []
          const importedNoExclusion = [];
          const importedWithExclusion = [];
          const orphans = [];
          const notImportedCount = [];

          // fill series for each stats
          response.data.forEach(stat => {

            const sampleFullDate = new Date(stat.certificationDate);
            // remove time from date time
            const sampleDate = new Date(sampleFullDate.getFullYear(), sampleFullDate.getMonth(), sampleFullDate.getDate());

            dates.push(sampleDate.toString())
            importedNoExclusion.push(stat.importedNoExclusionCount);
            importedWithExclusion.push(stat.importedWithExclusionCount);
            orphans.push(stat.orphansCount);
            notImportedCount.push(stat.notImportedCount);

          });
          
          const importedNoExclusionSerie = {
            name:  this.$t('GradeControl.Sample.ImportedNoExclusion'),
            data: importedNoExclusion
          }

          const importedWithExclusionSerie = {
            name:  this.$t('GradeControl.Sample.ImportedWithExclusion'),
            data: importedWithExclusion
          }

          const orphansSerie = {
            name:  this.$t('GradeControl.Sample.Orphan'),
            data: orphans
          }

          const notImportedCountSerie = {
            name:  this.$t('GradeControl.Sample.NotImported'),
            data: notImportedCount
          }

          const xaxis =  {
            type: 'datetime',
            categories: dates
          };

          this.series = [importedNoExclusionSerie, importedWithExclusionSerie, orphansSerie, notImportedCountSerie];

          this.$refs.chart.updateSeries(this.series, false, true);
          this.$refs.chart.updateOptions({ xaxis });
          resolve();

        }).catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: this.$t("LoadingError"),
            text: error.message  
          })
          reject(error);
        }).finally(() => {
          this.$vs.loading.close();
        })
      })
    },
    dataPointSelectionHandler(e, chartContext, config) {
      const date = chartContext.data.twoDSeriesX[config.dataPointIndex]
      
      if (typeof date !== 'undefined') {
        this.$emit("onDateSelected", new Date(date));
      }
    }
  }
};
</script>

<style lang="scss">
  .chartContainer {
    min-width: 300px;
    max-width: 500px;
    min-height: 545px;
    overflow-y: none;
    overflow-x: auto;
  }

</style>

